import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

export function useCounselingHead() {
  useHead({
    title: '無料相談・カウンセリングのご案内 |テックアカデミー',
    meta: [
      ...metaTags(
        {
          description:
            'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマやデザイナーに体験談などを無料で聞ける。',
          ogUrl: '/counseling/htmlcss-schedule',
          noIndexNofollow: false,
        },
      ),
    ],
    script: scriptTagsByConfig({
      env: process.env.NODE_ENV as 'production' | 'development',
      useCase: 'index',
      deviceSize: useNuxtApp().$deviceSize
    })!.script,
    noscript: scriptTagsByConfig({
      env: process.env.NODE_ENV as 'production' | 'development',
      useCase: 'index',
      deviceSize: useNuxtApp().$deviceSize
    })!.noscript,
  })
}
